// Common translations: banner, nav, hero, features, common, team, partners,
// contact, footer, cta, a11y

const common = {
  en: {
    banner: {
      label: "HOT DEAL",
      text: "KVM Ryzen VPS — from €2.35/month",
      cta: "Order now",
      close: "Close banner",
    },
    nav: {
      home: "Home",
      domains: "Domains",
      domainCheck: "Domain Check",
      domainRegister: "Register Domain",
      domainTransfer: "Transfer Domain",
      webhosting: "Web Hosting",
      webhostingSSD: "SSD Web Hosting",
      webhostingNVMe: "NVMe Web Hosting",
      nextcloud: "Nextcloud Hosting",
      vps: "VPS",
      storageVps: "Storage VPS",
      kvmRyzen: "KVM VPS Ryzen",
      kvmVps: "KVM VPS",
      windowsVps: "Windows VPS",
      rootserver: "Root Server",
      linuxRoot: "KVM Root Server",
      windowsRoot: "Windows Root Server",
      dedicated: "Dedicated Server",
      dedicatedStandard: "Dedicated Server",
      dedicatedPremium: "Premium Dedicated",
      dedicatedSale: "Sale Servers",
      teamspeak: "Teamspeak 3/5",
      licenses: "Licenses",
      gameservers: "Game Servers",
      vpn: "VPN",
      ssl: "SSL",
      customerArea: "Customer Area",
      productFinder: "Product Finder",
    },
    hero: {
      tagline: "Fast. Reliable. Prepaid.",
      title: "Your Server,",
      titleHighlight: "Your Rules",
      description: "Since 2013, we've been providing high-performance hosting solutions. Game servers, VPS, Dedicated Servers, and more — all without contracts.",
      cta: "Explore Products",
      ctaSecondary: "Find Your Server",
    },
    features: {
      title: "Why DeinServerHost?",
      subtitle: "We combine cutting-edge technology with transparent pricing",
      security: { title: "DDoS Protection", description: "Your servers are protected from known DDoS threats with our enterprise-grade protection." },
      scalable: { title: "Scalable", description: "Modify your server specs anytime. Pay only for what you need." },
      hardware: { title: "Modern Hardware", description: "We continuously upgrade our infrastructure to meet the latest requirements." },
      support: { title: "Support", description: "Our support team is available Mon–Fri, 08:00–12:00 & 14:00–18:00 CET." },
      prepaid: { title: "Prepaid Model", description: "No contracts, no hidden fees. Top up and use — it's that simple." },
      performance: { title: "High Performance", description: "Latest AMD EPYC and Intel Xeon processors with NVMe storage." },
    },
    common: {
      loading: "Loading...",
      error: "Something went wrong",
      retry: "Try Again",
      viewAll: "View All",
      learnMore: "Learn More",
      orderNow: "Order Now",
      buyNow: "Buy Now",
      viewPlans: "View Plans",
      popular: "Popular",
      recommended: "Recommended",
      perMonth: "/month",
      perYear: "/year",
      notFoundTitle: "Page not found",
      notFoundDesc: "The page you are looking for doesn't exist or has been moved.",
      backHome: "Back to the homepage",
      from: "From",
      month: "month",
      year: "year",
      free: "Free",
      bestMatch: "Best Match",
      included: "Included",
      emailAccounts: "email accounts",
      databases: "databases",
      domainsAssignable: "domains assignable",
      domainsIncluded: "Domain incl.",
      domainsNote: "* Request domains by ticket after ordering (14-day deadline)",
      startProductFinder: "Start Product Finder",
    },
    team: {
      title: "Meet Our Team",
      subtitle: "Dedicated professionals working to make your projects succeed",
      owner: "Owner",
      support: "Support",
      development: "Development",
      community: "Community Support",
    },
    partners: {
      title: "Partner Program",
      subtitle: "We help young talents and projects achieve their dreams",
      inquire: "Become a Partner",
      viewAll: "View Partners",
    },
    contact: {
      title: "Get in Touch",
      subtitle: "Have questions? We're happy to help!",
      name: "Your Name",
      email: "Your Email",
      message: "Your Message",
      placeholder: "How can we help you?",
      send: "Send Message",
      success: "Message sent successfully!",
      error: "Failed to send message. Please try again.",
    },
    footer: {
      tagline: "Your reliable hosting partner since 2013",
      products: "Products",
      company: "Company",
      legal: "Legal",
      support: "Support",
      about: "About Us",
      team: "Our Team",
      partners: "Partners",
      careers: "Careers",
      imprint: "Imprint",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      cookies: "Cookie Settings",
      faq: "FAQ",
      ticket: "Submit Ticket",
      status: "System Status",
      copyright: "© {year} DeinServerHost. All rights reserved.",
    },
    cta: {
      title: "Ready to Start?",
      subtitle: "Join thousands of satisfied customers",
      button: "Get Started",
      login: "Login",
      signup: "Sign Up",
    },
    a11y: {
      skipToContent: "Skip to main content",
      toggleTheme: "Toggle theme",
      openMenu: "Open menu",
      closeMenu: "Close menu",
      languageSelector: "Select language",
    },
  },

  de: {
    banner: {
      label: "HOT DEAL",
      text: "KVM Ryzen VPS — ab 2,35 €/Monat",
      cta: "Jetzt bestellen",
      close: "Banner schließen",
    },
    nav: {
      home: "Startseite",
      domains: "Domains",
      domainCheck: "Domain prüfen",
      domainRegister: "Domain registrieren",
      domainTransfer: "Domain transferieren",
      webhosting: "Web-Hosting",
      webhostingSSD: "SSD Web-Hosting",
      webhostingNVMe: "NVMe Web-Hosting",
      nextcloud: "Nextcloud-Hosting",
      vps: "VPS",
      storageVps: "Storage VPS",
      kvmRyzen: "KVM VPS Ryzen",
      kvmVps: "KVM VPS",
      windowsVps: "Windows VPS",
      rootserver: "Rootserver",
      linuxRoot: "KVM Rootserver",
      windowsRoot: "Windows Rootserver",
      dedicated: "Dedicated Server",
      dedicatedStandard: "Dedicated Server",
      dedicatedPremium: "Premium Dedicated",
      dedicatedSale: "Angebote",
      teamspeak: "Teamspeak 3/5",
      licenses: "Lizenzen",
      gameservers: "Gameserver",
      vpn: "VPN",
      ssl: "SSL",
      customerArea: "Kundenbereich",
      productFinder: "Produkt-Finder",
    },
    hero: {
      tagline: "Schnell. Zuverlässig. Prepaid.",
      title: "Dein Server,",
      titleHighlight: "Deine Regeln",
      description: "Seit 2013 bieten wir leistungsstarke Hosting-Lösungen. Gameserver, VPS, Dedicated Server und mehr — alles ohne Vertragsbindung.",
      cta: "Produkte entdecken",
      ctaSecondary: "Server finden",
    },
    features: {
      title: "Warum DeinServerHost?",
      subtitle: "Wir verbinden modernste Technologie mit transparenten Preisen",
      security: { title: "DDoS-Schutz", description: "Deine Server sind durch unseren Enterprise-DDoS-Schutz vor bekannten Angriffen gesichert." },
      scalable: { title: "Skalierbar", description: "Passe deine Server-Ressourcen jederzeit an. Zahle nur für das, was du brauchst." },
      hardware: { title: "Moderne Hardware", description: "Wir aktualisieren unsere Infrastruktur kontinuierlich, um die neuesten Anforderungen zu erfüllen." },
      support: { title: "Support", description: "Unser Support-Team ist Mo–Fr, 08:00–12:00 & 14:00–18:00 Uhr MEZ erreichbar." },
      prepaid: { title: "Prepaid-Modell", description: "Keine Verträge, keine versteckten Gebühren. Aufladen und nutzen – so einfach ist das." },
      performance: { title: "Hohe Performance", description: "Neueste AMD EPYC und Intel Xeon Prozessoren mit NVMe-Speicher." },
    },
    common: {
      loading: "Laden...",
      error: "Etwas ist schiefgelaufen",
      retry: "Erneut versuchen",
      viewAll: "Alle ansehen",
      learnMore: "Mehr erfahren",
      orderNow: "Jetzt bestellen",
      buyNow: "Jetzt kaufen",
      viewPlans: "Tarife ansehen",
      popular: "Beliebt",
      recommended: "Empfohlen",
      perMonth: "/Monat",
      perYear: "/Jahr",
      notFoundTitle: "Seite nicht gefunden",
      notFoundDesc: "Die gesuchte Seite existiert nicht oder wurde verschoben.",
      backHome: "Zurück zur Startseite",
      from: "Ab",
      month: "Monat",
      year: "Jahr",
      free: "Kostenlos",
      bestMatch: "Beste Wahl",
      included: "Inklusive",
      emailAccounts: "E-Mail-Konten",
      databases: "Datenbanken",
      domainsAssignable: "Domains zuweisbar",
      domainsIncluded: ".DE Domain inkl.",
      domainsNote: "* Domains nach Bestellung per Ticket anfordern (14 Tage Frist)",
      startProductFinder: "Produkt-Finder starten",
    },
    team: {
      title: "Unser Team",
      subtitle: "Engagierte Profis, die deine Projekte zum Erfolg führen",
      owner: "Inhaber",
      support: "Support",
      development: "Entwicklung",
      community: "Community Support",
    },
    partners: {
      title: "Partnerprogramm",
      subtitle: "Wir helfen jungen Talenten und Projekten, ihre Träume zu verwirklichen",
      inquire: "Partner werden",
      viewAll: "Alle Partner",
    },
    contact: {
      title: "Kontakt",
      subtitle: "Hast du Fragen? Wir helfen gerne!",
      name: "Dein Name",
      email: "Deine E-Mail",
      message: "Deine Nachricht",
      placeholder: "Wie können wir dir helfen?",
      send: "Nachricht senden",
      success: "Nachricht erfolgreich gesendet!",
      error: "Fehler beim Senden. Bitte erneut versuchen.",
    },
    footer: {
      tagline: "Dein zuverlässiger Hosting-Partner seit 2013",
      products: "Produkte",
      company: "Unternehmen",
      legal: "Rechtliches",
      support: "Support",
      about: "Über uns",
      team: "Unser Team",
      partners: "Partner",
      careers: "Karriere",
      imprint: "Impressum",
      privacy: "Datenschutz",
      terms: "AGB",
      cookies: "Cookie-Einstellungen",
      faq: "FAQ",
      ticket: "Ticket einreichen",
      status: "Systemstatus",
      copyright: "© {year} DeinServerHost. Alle Rechte vorbehalten.",
    },
    cta: {
      title: "Bereit loszulegen?",
      subtitle: "Schließe dich tausenden zufriedener Kunden an",
      button: "Jetzt starten",
      login: "Anmelden",
      signup: "Registrieren",
    },
    a11y: {
      skipToContent: "Zum Hauptinhalt springen",
      toggleTheme: "Theme wechseln",
      openMenu: "Menü öffnen",
      closeMenu: "Menü schließen",
      languageSelector: "Sprache auswählen",
    },
  },
};

export default common;
